import { useNavigate } from 'react-router-dom';
import patterns from '../data/patterns';
import { getIcon, ArrowRight, MultiAgent, Skills, PromptLibrary } from '../components/Icons';

function PatternCard({ pattern, index }) {
  const navigate = useNavigate();
  const Icon = getIcon(pattern.icon);

  return (
    <div
      className={`pattern-card page-enter stagger-${index + 1}`}
      onClick={() => navigate(`/patterns/${pattern.id}`)}
    >
      <div className="card-accent" style={{ background: pattern.color }} />
      <div className="pattern-card-icon">{Icon && <Icon />}</div>
      <h3>{pattern.title}</h3>
      <p>{pattern.subtitle}</p>
      <div className="card-arrow">
        <ArrowRight />
      </div>
    </div>
  );
}

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="page-enter">
      <div className="hero">
        <div className="hero-badge">✦ Open Knowledge for DevOps Teams</div>
        <h1>
          <span className="gradient">AI Patterns</span>
          <br />
          for DevOps
        </h1>
        <p>
          Learn the fundamental building blocks of AI-powered DevOps: from
          prompts to multi-agent systems. Practical patterns, real examples, no
          hype.
        </p>
      </div>

      <div className="pattern-grid">
        {patterns.map((p, i) => (
          <PatternCard key={p.id} pattern={p} index={i} />
        ))}
      </div>

      {/* Feature links */}
      <div className="feature-card" onClick={() => navigate('/prompts')}>
        <div className="feature-card-icon">
          <PromptLibrary />
        </div>
        <div>
          <h3>Prompt Library →</h3>
          <p>
            Production-ready prompt templates for CI/CD, IaC, monitoring,
            security, incident response, and Kubernetes.
          </p>
        </div>
      </div>

      <div className="feature-card" onClick={() => navigate('/agents')}>
        <div className="feature-card-icon">
          <MultiAgent />
        </div>
        <div>
          <h3>Our Multi-Agent System →</h3>
          <p>
            21 specialized agents across CI/CD, Infrastructure as Code, and
            Observability — with 124 skills total.
          </p>
        </div>
      </div>

      <div className="feature-card" onClick={() => navigate('/learning')}>
        <div className="feature-card-icon">
          <Skills />
        </div>
        <div>
          <h3>Learning Path →</h3>
          <p>
            Step-by-step guide: from zero to production multi-agent system in
            12-16 weeks.
          </p>
        </div>
      </div>
    </div>
  );
}
